module.exports = __webpack_public_path__ + "img/super-sorted.cc316af6.png";